import { FormControl, TextField, Autocomplete, Snackbar, Alert, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { stringifyJSONAttributes, stringToBooleanConversion, decryptString, encryptString } from '../../../utils/utilFunctions';
import { useDispatch } from 'react-redux';
import { api } from '../../../redux/api';
import { isInValidInput, sanitizeInput } from '../../../utils/validate';
import ErrorModal from '../../ItemProperties/Forms/FieldDataValidation/ErrorModal';
import SmartPasswordField from '../../../commonComponents/SmartPasswordField';
import { MoreHorizOutlined } from '@mui/icons-material';
import WorkflowSessionModal from '../../ItemProperties/WorkflowSessionModal';
import _ from 'lodash';

const Cmd = ({ connectionDetails, handleBodyContent, direction, account, screen, disableControl, repoPDC, useConnection, fileMaskName }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [executable, setExecutable] = useState('');
    const [argument, setArgument] = useState('');
    const [fileName, setFileName] = useState('');
    const [decompression, setDecompression] = useState(false);
    const [streamArg, setStreamArg] = useState(false);
    const [showDecompressionDir, setShowDecompressionDir] = useState(false);
    const [decompressionDir, setDecompressionDir] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState('');
    const [script, setScript] = useState('');
    const [content, setContent] = useState(null);

    // Data Destination connection
    const [compression, setCompression] = useState(false);
    const [streamData, setStreamData] = useState(false);
    const [compressionList, setCompressionList] = useState([]);
    const [compressionType, setCompressionType] = useState('');
    const [fileNameZip, setFileNameZip] = useState('');
    const [showDestinationPassword, setShowDestinationPassword] = useState(false);
    const [destinationPassword, setDestinationPassword] = useState('');
    const [errorModal, setErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showAlert, setShowAlert] = useState({ mssg: '', type: 'success', isOpen: false });
    const [workflowSessionModal, setWorkflowSessionModal] = useState({open: false, isFirstTime: false});
    const [valueLabel, setValueLabel] = useState("");

    const handleAlertClose = () => {
        setShowAlert({ ...showAlert, isOpen: false });
    }

    const onInputChange = (name, value, cb) => {
        if (cb){
            cb();
            return;
        }
        if (screen === 'GET_DATA' || screen === 'SEND_DATA') {
            if (name === "ZIP_PASSWORD") {
                setContent((prev) => {
                    return {[name]: encryptString(value, process.env.REACT_APP_SECRET_KEY2) };
                });
            }
            else {
                setContent((prev) => {
                    return { [name]: value };
                });
            }
        } else {
            setContent((prev) => {
                return { ...prev, [name]: value };
            });
        }
    }

    const removeUndefinedAndNullKeys = (obj = {}) => {
        const tempObj = {...obj}
        Object.keys(tempObj || {}).forEach(e => {
            if(tempObj[e] === undefined || tempObj[e] === null) delete tempObj[e];
        })
        return tempObj
    }

    const debouncedContentUpdate = debounce(handleBodyContent, 500);

    const handleBlur = () => {
        const res = isInValidInput(fileName);
        if (res.inValid) {
            setErrorModal(true);
            setErrorMessage(res.message);
        } else {
            setErrorModal(false);
            setErrorMessage(res.message);
        }
    }

    const inputConverter = () => {
        const sanitizeResult = sanitizeInput(fileName);
        onInputChange('FILENAME', sanitizeResult);
        setFileName(sanitizeResult);
        setErrorModal(false);
        setErrorMessage('');
    }
    const handleCompressionTypeChange = (value) => {
        setCompressionType(value);
        if(["GZ", "TAR", "TGZ"].includes(value)){
            setShowDestinationPassword(false);
            setDestinationPassword("");
            if(screen && screen === 'SEND_DATA'){
                onInputChange('add',{ZIP: value, USE_ZIP_PASSWORD:'FALSE', ZIP_PASSWORD: null})
              } else {
                onInputChange("ZIP", value);
                onInputChange("USE_ZIP_PASSWORD",stringifyJSONAttributes(false));
                onInputChange("ZIP_PASSWORD", "");
              }
        } else {
            onInputChange("ZIP", value);
        }
    }
    useEffect(() => {
        setExecutable(connectionDetails?.CMD || 'CMD');
        setArgument(connectionDetails?.CMD_ARGS || '');
        setFileName(connectionDetails?.FILENAME || '');
        setStreamArg(stringToBooleanConversion(connectionDetails?.STREAM_ARGS));
        if (connectionDetails?.ZIP) {
            setDecompression(true);
            setCompression(true);
        } else {
            setDecompression(false);
            setCompression(false);
        }
        setShowPassword(stringToBooleanConversion(connectionDetails?.USE_ZIP_PASSWORD));
        setDecompressionDir(connectionDetails?.DECOMPRESSION_DIRECTORY || '');
        if ((connectionDetails?.DECOMPRESSION_DIRECTORY && connectionDetails?.DECOMPRESSION_DIRECTORY?.length !== 0) || stringToBooleanConversion(connectionDetails?.SPECIFY_DECOMPRESSION_DIRECTORY)) setShowDecompressionDir(true);
        else setShowDecompressionDir(false);
        
        // Handle password decryption for GET_DATA and SEND_DATA
        if (screen === 'GET_DATA' || screen === 'SEND_DATA') {
            setPassword(
                decryptString(
                    (connectionDetails?.ZIP_PASSWORD || ""),
                    process.env.REACT_APP_SECRET_KEY2
                ) || ''
            );
            setDestinationPassword(
                decryptString(
                    (connectionDetails?.ZIP_PASSWORD || ""),
                    process.env.REACT_APP_SECRET_KEY2
                ) || ''
            );
        } else {
            setPassword(connectionDetails?.ZIP_PASSWORD || '');
            setDestinationPassword(connectionDetails?.ZIP_PASSWORD || '');
        }
        
        setScript(connectionDetails?.SCRIPT || '');
        // Destination
        setStreamData(stringToBooleanConversion(connectionDetails?.STREAM_DATA));
        setCompressionType(connectionDetails?.ZIP  || 'ZIP');
        setFileNameZip(connectionDetails?.FILE_NAME_WITHIN_ZIP || '');
        if (direction === 'OUT') {
            setShowDestinationPassword(stringToBooleanConversion(connectionDetails?.USE_ZIP_PASSWORD));
        }
        setContent({ ...connectionDetails })
    }, [connectionDetails]);

    useEffect(() => {
        if(!_.isEqual(removeUndefinedAndNullKeys(content), removeUndefinedAndNullKeys(connectionDetails))) {
            debouncedContentUpdate(content);
        }
    }, [content]);


    useEffect(() => {
        if (direction === 'OUT') {
            dispatch(api.endpoints.getCompressionList.initiate()).then((res) => {
                if (res?.data?.current_state === 'SUCCESS') {
                    const types = Object.values(res?.data?.data)?.map((item) => item?.TYPE)
                    setCompressionList(types);
                }
                if (res?.data?.current_state === 'ERROR') {
                    setShowAlert({ mssg: res?.data?.message, isOpen: true, type: 'error' });
                }
            });
        }
    }, [direction]);

    const getFontWeight = (control, currentValue, useConnection) => {
        
        if (!repoPDC) return "normal";
        if (control === "CMD" && (currentValue === t('CMD') || !currentValue) && !repoPDC?.CMD) return "normal";
        return repoPDC?.[control] !== currentValue &&
            useConnection === "preDefined"
            ? "bold"
            : "normal";
    };

    const fontWeights = {
        executable: getFontWeight("CMD", executable, useConnection),
        argument: getFontWeight("CMD_ARGS", argument, useConnection),
        fileName: getFontWeight("FILENAME", fileName, useConnection),
        script: getFontWeight("SCRIPT", script, useConnection),
        decompressionDir: getFontWeight("DECOMPRESSION_DIRECTORY", decompressionDir, useConnection),
        password: getFontWeight("ZIP_PASSWORD", password, useConnection),
        fileNameZip: getFontWeight("FILE_NAME_WITHIN_ZIP", fileNameZip, useConnection),
        destinationPassword: getFontWeight("ZIP_PASSWORD", destinationPassword, useConnection),
        compressionType: getFontWeight("COMPRESSION_TYPE", compressionType, useConnection)
    };

    return (
        <>
            <div style={{display:'flex', gap:'4px'}}>
                <Autocomplete
                    disablePortal
                    options={[t('CMD'), t('KSH')]}
                    value={executable}
                    sx={{ maxHeight: 300, width: '100%' }}
                    disabled={disableControl || false}
                    onChange={(e, value) => {
                        onInputChange('CMD', value);
                        setExecutable(value)
                    }}
                    
                    renderInput={(params) => <TextField
                        {...params}
                        label={t("LBL_EXECUTABLE")}
                        value={executable || t('CMD')}
                        onChange={(event, value) => {
                            onInputChange('CMD', event.target.value);
                            setExecutable(event.target.value)
                        }}
                        variant="outlined"
                        size="small"
                        name={"CMD"}
                        autoComplete="off"
                        inputProps={{
                            ...params.inputProps,
                            style: { fontWeight: fontWeights.executable }
                        }}
                    />
                    }
                />
            </div>
            <div style={{display:'flex', gap:'4px'}}>
                <FormControl className="width-100" size="small">
                    <TextField
                        variant="outlined"
                        size="small"
                        disabled={disableControl || false}
                        label={t("LBL_ARGUMENTS")}
                        type="text"
                        value={argument || ''}
                        onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setArgument(e.target.value);
                        }}
                        className={"width-100"}
                        name={"CMD_ARGS"}
                        autoComplete="off"
                        inputProps={{
                            style: { fontWeight: fontWeights.argument }
                        }}
                    />
                </FormControl>
                {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                    <Button
                        size="small"
                        disabled={disableControl || false}
                        variant="outlined"
                        onClick={() => {
                            setValueLabel(t("LBL_ARGUMENTS"));
                            setWorkflowSessionModal({ open: true, isFirstTime: true });
                        }}
                        sx={{ width: "40px", minWidth: "40px" }}>
                        <MoreHorizOutlined fontSize="small" />
                    </Button>
                )}
            </div>
            <div style={{display:'flex', gap:'4px'}}>
                <FormControl className="width-100" size="small">
                    <TextField
                        variant="outlined"
                        size="small"
                        disabled={fileMaskName?.includes("*") || fileMaskName?.includes("?") || fileMaskName?.includes(":") || disableControl || false}
                        label={t("LBL_FILE_NAME")}
                        type="text"
                        value={fileName || ''}
                        onChange={(e) => {
                            setFileName(e.target.value);
                            onInputChange('FILENAME', e.target.value);
                        }}
                        onBlur={handleBlur}
                        className={"width-100"}
                        name={"FILENAME"}
                        autoComplete="off"
                        inputProps={{
                            style: { fontWeight: fontWeights.fileName }
                        }}
                    />
                </FormControl>
                {((screen && screen === 'GET_DATA') || (screen && screen === 'SEND_DATA')) && (
                    <Button
                        size="small"
                        disabled={fileMaskName?.includes("*") || fileMaskName?.includes("?") || fileMaskName?.includes(":") || disableControl || false}
                        variant="outlined"
                        onClick={() => {
                            setValueLabel(t("LBL_FILE_NAME"));
                            setWorkflowSessionModal({ open: true, isFirstTime: true });
                        }}
                        sx={{ width: "40px", minWidth: "40px" }}>
                        <MoreHorizOutlined fontSize="small" />
                    </Button>
                )}
            </div>
            <div className='flex flex-wrap'>
                {direction === 'IN' && <TPCheckbox
                    label={t("BTN_USE_ZIP_DECOMPRESS")}
                    checked={decompression}
                    disabled={disableControl || connectionDetails?.hasOwnProperty("ENCRYPTION_TYPE") || false}
                    handleCheck={(checked) => {
                        if (checked) onInputChange('ZIP', 'ZIP');
                        else onInputChange('ZIP', null);
                        setDecompression(checked);
                        if (!checked && !screen) {
                            onInputChange('SPECIFY_DECOMPRESSION_DIRECTORY', stringifyJSONAttributes(false));
                            setShowDecompressionDir(false);
                            onInputChange('DECOMPRESSION_DIRECTORY', '');
                            setDecompressionDir('');
                            onInputChange('USE_ZIP_PASSWORD', stringifyJSONAttributes(false));
                            setShowPassword(false);
                            onInputChange('ZIP_PASSWORD', '');
                            setPassword('');
                        }
                    }}
                />}
                {direction === 'OUT' && <TPCheckbox
                    label={t("BTN_USE_ZIP_COMPRESS")}
                    checked={compression}
                    disabled={disableControl || connectionDetails?.hasOwnProperty("ENCRYPTION_TYPE") || false}
                    handleCheck={(checked) => {
                        if (screen === 'GET_DATA' || screen === 'SEND_DATA' ) {
                            if (checked) onInputChange('ZIP', 'ZIP');
                            else onInputChange('ZIP', null);
                        }
                        else onInputChange('COMPRESSION', stringifyJSONAttributes(checked));
                        setCompression(checked);
                        if (!checked && !screen) {
                            setCompressionType('ZIP');
                            onInputChange('COMPRESSION_TYPE', 'ZIP');
                            setFileNameZip('');
                            onInputChange('FILE_NAME_WITHIN_ZIP', '');
                            setShowDestinationPassword(false);
                            onInputChange('USE_ZIP_PASSWORD', stringifyJSONAttributes(false));
                            setDestinationPassword('');
                            onInputChange('ZIP_PASSWORD', '');
                        }
                    }}
                />}
                <TPCheckbox
                    label={t("BTN_STREAM_ARGS")}
                    checked={streamArg}
                    disabled={disableControl || false}
                    handleCheck={(checked) => {
                        if (screen === 'GET_DATA' || screen === 'SEND_DATA') {
                            if (checked) {
                                setStreamData(false);
                                setStreamArg(checked);
                                onInputChange(null, null, () => {
                                    setContent({
                                        add: {
                                            STREAM_DATA: "FALSE",
                                            STREAM_ARGS: "TRUE",
                                        }
                                    })
                                })
                            }
                            else {
                                setStreamData(false);
                                setStreamArg(false);
                                onInputChange(null, null, () => {
                                    setContent({
                                        add: {
                                            STREAM_DATA: "FALSE",
                                            STREAM_ARGS: "FALSE",
                                        }
                                    })
                                })
                            }
                        }else {
                            onInputChange('STREAM_ARGS', stringifyJSONAttributes(checked));
                            onInputChange('STREAM_DATA', stringifyJSONAttributes(false));
                            setStreamArg(checked);
                            setStreamData(false);
                        }
                    }}
                />
                {direction === 'OUT' && <TPCheckbox
                    label={t("BTN_STREAM_DATA")}
                    checked={streamData}
                    disabled={disableControl || false}
                    handleCheck={(checked) => {
                        if (screen === 'GET_DATA' || screen === 'SEND_DATA') {
                            if (checked) {
                                setStreamData(true);
                                setStreamArg(false);
                                onInputChange(null, null, () => {
                                    setContent({
                                        add: {
                                            STREAM_DATA: "TRUE",
                                            STREAM_ARGS: "FALSE",
                                        }
                                    })
                                })
                            }
                            else {
                                setStreamData(false);
                                setStreamArg(false);
                                onInputChange(null, null, () => {
                                    setContent({
                                        add: {
                                            STREAM_DATA: "FALSE",
                                            STREAM_ARGS: "FALSE",
                                        }
                                    })
                                })
                            }
                        }else {
                            onInputChange('STREAM_DATA', stringifyJSONAttributes(checked));
                            onInputChange('STREAM_ARGS', stringifyJSONAttributes(false));
                            setStreamArg(false);
                            setStreamData(checked);
                        }
                    }}
                />}
            </div>
            {decompression && direction === 'IN' && <>
                <div>
                    <TPCheckbox
                        label={t("LBL_SPECIFY_DECOMPRESSION_DIRECTORY")}
                        checked={showDecompressionDir}
                        disabled={disableControl || false}
                        handleCheck={(checked) => {
                            onInputChange('SPECIFY_DECOMPRESSION_DIRECTORY', stringifyJSONAttributes(checked));
                            setShowDecompressionDir(checked);
                            if (!checked) {
                                onInputChange('DECOMPRESSION_DIRECTORY', '');
                                setDecompressionDir('');
                            }
                        }}
                    />
                </div>
                {
                    showDecompressionDir && (
                        <div style={{display:'flex', gap:'4px'}}>
                            <FormControl className="width-100" size="small">
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    disabled={disableControl || false}
                                    label={t("LBL_DECOMPRESS_DIRECTORY")}
                                    type="text"
                                    value={decompressionDir || ''}
                                    onChange={(e) => {
                                        onInputChange(e.target.name, e.target.value);
                                        setDecompressionDir(e.target.value)
                                    }}
                                    className={"width-100"}
                                    name={"DECOMPRESSION_DIRECTORY"}
                                    autoComplete="off"
                                    inputProps={{
                                        style: { fontWeight: fontWeights.decompressionDir }
                                    }}
                                />
                            </FormControl>
                        </div>
                    )
                }
                <div>
                    <TPCheckbox
                        label={t("LBL_WS_PASSWORD")}
                        checked={showPassword}
                        disabled={disableControl || false}
                        handleCheck={(checked) => {
                            onInputChange('USE_ZIP_PASSWORD', stringifyJSONAttributes(checked));
                            setShowPassword(checked);
                            if (!checked) {
                                setPassword('');
                                onInputChange('ZIP_PASSWORD', '');
                            }
                        }}
                    />
                </div>
                {showPassword && (
                    <div style={{display:'flex', gap:'4px'}}>
                        <SmartPasswordField
                            variant="outlined"
                            size="small"
                            disabled={disableControl || false}
                            label={t("LBL_WS_PASSWORD")}
                            value={password || ''}
                            onChange={(e) => {
                                onInputChange(e.target.name, e.target.value);
                                setPassword(e.target.value)
                            }}
                            className={"width-100"}
                            name={"ZIP_PASSWORD"}
                            autoComplete="off"
                            inputProps={{
                                style: { fontWeight: fontWeights.password }
                            }}
                        />
                    </div>
                )}
            </>}
            {compression && direction === 'OUT' && <>
                <Autocomplete
                    disablePortal
                    disabled={disableControl || false}
                    options={compressionList}
                    getOptionLabel={(option) => option}
                    value={compressionType}
                    sx={{ maxHeight: 300 }}
                    onChange={(e, value) => {
                     handleCompressionTypeChange(value);
                    }}
                    renderInput={(params) => <TextField
                        {...params}
                        label={t("LBL_COMPRESSION_TYPE")}
                        onChange={(e) => {
                            const value = e.target.value;
                            handleCompressionTypeChange(value);
                        }}
                        variant="outlined"
                        size="small"
                        name={'COMPRESSION_TYPE'}
                        autoComplete="off"
                        disabled={disableControl || false}
                        inputProps={{
                            ...params.inputProps,
                            style: { fontWeight: fontWeights.compressionType }
                        }}
                    />
                    }
                />
                <div style={{display:'flex', gap:'4px'}}>
                    <FormControl className="width-100" size="small">
                        <TextField
                            variant="outlined"
                            size="small"
                            disabled={disableControl || false}
                            label={t("FILE_NAME_WITHIN_ZIP")}
                            type="text"
                            value={fileNameZip || ''}
                            onChange={(e) => {
                                onInputChange(e.target.name, e.target.value);
                                setFileNameZip(e.target.value);
                            }}
                            className={"width-100"}
                            name={"FILE_NAME_WITHIN_ZIP"}
                            autoComplete="off"
                            inputProps={{
                                style: { fontWeight: fontWeights.fileNameZip }
                            }}
                        />
                    </FormControl>
                </div>
                {
                    ['JAR', 'RAR', 'ZIP'].includes(compressionType) && <>
                        <div>
                            <TPCheckbox
                                label={t("LBL_WS_PASSWORD")}
                                checked={showDestinationPassword}
                                disabled={disableControl || false}
                                handleCheck={(checked) => {
                                    onInputChange('USE_ZIP_PASSWORD', stringifyJSONAttributes(checked));
                                    setShowDestinationPassword(checked);
                                    if (!checked) {
                                        onInputChange('ZIP_PASSWORD', '');
                                        setDestinationPassword('');
                                    }
                                }}
                            />
                        </div>
                        {showDestinationPassword && (
                            <div style={{display:'flex', gap:'4px'}}>
                                <SmartPasswordField
                                    variant="outlined"
                                    size="small"
                                    disabled={disableControl || false}
                                    label={t("LBL_WS_PASSWORD")}
                                    value={destinationPassword || ''}
                                    onChange={(e) => {
                                        onInputChange(e.target.name, e.target.value);
                                        setDestinationPassword(e.target.value);
                                    }}
                                    className={"width-100"}
                                    name={"ZIP_PASSWORD"}
                                    autoComplete="off"
                                    inputProps={{
                                        style: { fontWeight: fontWeights.destinationPassword }
                                    }}
                                />
                            </div>
                        )}
                    </>
                }
            </>}
            <div style={{display:'flex', gap:'4px'}}>
                <FormControl className="width-100" size="small">
                    <TextField
                        multiline
                        rows={4}
                        variant="outlined"
                        size="small"
                        disabled={disableControl || false}
                        label={t("LBL_SCRIPT")}
                        type="text"
                        value={script || ''}
                        onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setScript(e.target.value);
                        }}
                        className={"width-100"}
                        name={"SCRIPT"}
                        autoComplete="off"
                        inputProps={{
                            style: { fontWeight: fontWeights.script }
                        }}
                    />
                </FormControl>
            </div>
            <ErrorModal
                errorModal={errorModal}
                setErrorModal={() => setErrorModal(false)}
                errorMessage={errorMessage}
                OkHandler={inputConverter}
            />
            <WorkflowSessionModal
                valueLabel={valueLabel}
                showAccountData={true}
                showCallingWorkflow={true}
                showSystemData={true}
                showWorkflowSession={true}
                showDateAndTime={true}
                openModal={workflowSessionModal}
                setModalOpen={setWorkflowSessionModal}
                handleClose={() =>
                    setWorkflowSessionModal({ open: false, isFirstTime: false })
                }
                initialValue={
                    valueLabel === t("LBL_EXECUTABLE")
                        ? executable
                        : valueLabel === t("LBL_ARGUMENTS")
                        ? argument
                        : valueLabel === t("LBL_FILE_NAME")
                        ? fileName
                        : valueLabel === t("LBL_DECOMPRESS_DIRECTORY")
                        ? decompressionDir
                        : valueLabel === t("LBL_WS_PASSWORD")
                        ? password
                        : valueLabel === t("FILE_NAME_WITHIN_ZIP")
                        ? fileNameZip
                        : valueLabel === t("LBL_SCRIPT")
                        ? script
                        : ""
                }
                valuesHandler={(value) => {
                    if (valueLabel === t("LBL_EXECUTABLE")) {
                        onInputChange("CMD", value);
                        setExecutable(value);
                    } else if (valueLabel === t("LBL_ARGUMENTS")) {
                        onInputChange("CMD_ARGS", value);
                        setArgument(value);
                    } else if (valueLabel === t("LBL_FILE_NAME")) {
                        onInputChange("FILENAME", value);
                        setFileName(value);
                    } else if (valueLabel === t("LBL_DECOMPRESS_DIRECTORY")) {
                        onInputChange("DECOMPRESSION_DIRECTORY", value);
                        setDecompressionDir(value);
                    } else if (valueLabel === t("LBL_WS_PASSWORD")) {
                        onInputChange("ZIP_PASSWORD", value);
                        if (direction === 'IN') {
                            setPassword(value);
                        } else {
                            setDestinationPassword(value);
                        }
                    } else if (valueLabel === t("FILE_NAME_WITHIN_ZIP")) {
                        onInputChange("FILE_NAME_WITHIN_ZIP", value);
                        setFileNameZip(value);
                    } else if (valueLabel === t("LBL_SCRIPT")) {
                        onInputChange("SCRIPT", value);
                        setScript(value);
                    }
                }}
                inputType={valueLabel === t("LBL_WS_PASSWORD") ? "password" : "text"}
                specialPasswordField={valueLabel === t("LBL_WS_PASSWORD")}
            />
            <Snackbar open={showAlert.isOpen} onClose={() => handleAlertClose()}>
                <Alert
                    onClose={() => handleAlertClose()}
                    severity={showAlert.type}
                    variant="filled"
                    sx={{ width: "100%" }}>
                    {showAlert.mssg}
                </Alert>
            </Snackbar>
        </>
    )
}

export default Cmd